import type { Registration } from "@/models/Registration";
import { RegistrationService } from "@/services/RegistrationService";
import { defineStore } from "pinia";

interface RegistrationState {
    isLoading: boolean;
    verificationEmail: string | null;
    initial: string | undefined;
}

export const useRegistrationStore = defineStore("register", {
    state: (): RegistrationState => {
        return {
            isLoading: false,
            verificationEmail: null,
            initial: undefined
        };
    },

    persist: {
        storage: persistedState.localStorage,
    },

    getters: {},

    actions: {
        async postData(registration: Registration): Promise<void> {
            try {
                this.isLoading = true;
                await RegistrationService.register(registration);
            } catch (error) {
                this.isLoading = false;
                console.error(error);
                throw error;
            } finally {
                this.isLoading = false;
            }
        },
        async resetData(): Promise<void> {
            try {
                this.isLoading = true;
                const data = await RegistrationService.getRegistrationData();
                this.verificationEmail = data.emailAddress;
            } catch (error) {
                this.isLoading = false;
                console.error(error);
                throw error;
            } finally {
                this.isLoading = false;
            }
        },

    },
});

